import { render, staticRenderFns } from "./InformationList.vue?vue&type=template&id=bb75f1ce&scoped=true"
import script from "./InformationList.vue?vue&type=script&lang=js"
export * from "./InformationList.vue?vue&type=script&lang=js"
import style0 from "./InformationList.vue?vue&type=style&index=0&id=bb75f1ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb75f1ce",
  null
  
)

export default component.exports